import { DesktopWindowsOutlined } from '@mui/icons-material';

const DesktopAccessMessage = () => {
    return (
        <div className="block lg:hidden">
            <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
                <div className="text-center max-w-md mx-auto">
                    <div className="mb-3">
                        <DesktopWindowsOutlined className="text-blue-400" style={{ height: '60px', width: '60px' }} fontSize="small" />
                    </div>

                    <h2 className="text-xl font-semibold text-gray-900 mb-4">Desktop Access Required</h2>

                    <p className="text-gray-600 leading-relaxed">
                        To customize the hello:data search plugin, please access this feature on a desktop. The customization tools are currently optimized for
                        larger screens to ensure the best user experience.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DesktopAccessMessage;
